import { Box, Typography, useTheme } from '@mui/material';

// Referência visual de atalho de teclado no rodapé das dialogs de emissão
// fiscal (ex.: <KeyHint>F12</KeyHint>) — não é um botão clicável, só ensina
// o operador qual tecla usar sem ocupar espaço de verdade.
export const KeyHint: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useTheme();
  return (
    <Box
      component="kbd"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 22,
        height: 20,
        px: 0.6,
        border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.divider : '#CBD5E1'}`,
        bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : '#F8FAFC',
        borderRadius: '6px',
        fontFamily: 'inherit',
      }}
    >
      <Typography component="span" sx={{ fontSize: '0.7rem', fontWeight: 700, lineHeight: 1, color: 'text.primary' }}>
        {children}
      </Typography>
    </Box>
  );
};

// Uma linha "TECLA rótulo" pro rodapé (ex.: ↑↓ Navegar).
export const KeyHintRow: React.FC<{ keyLabel: React.ReactNode; children: React.ReactNode }> = ({ keyLabel, children }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
    <KeyHint>{keyLabel}</KeyHint>
    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.72rem' }}>
      {children}
    </Typography>
  </Box>
);
